import type { GroupProps } from '~/services/DetermineWinnerService/types';
import type { IAnalyticMetric } from '~/types/metric';

import {
  getTotalSessionCompletedCheckoutMetric,
  getTotalSessionMetric,
} from '~/modules/analytics/helpers/metric';
import { useDetermineWinner } from '~/services/DetermineWinnerService';
import { IVariantType } from '~/modules/campaign/types';
import { useMemo } from 'react';

export const useConversionRateWinner = ({
  metrics,
}: {
  metrics: IAnalyticMetric[] | undefined;
}) => {
  const control = useMemo<GroupProps>(() => {
    const metric = metrics?.find((m) => m?.variantKey === IVariantType.VARIANT_A);
    const views = getTotalSessionMetric({ metric }).value;
    const conversions = getTotalSessionCompletedCheckoutMetric({ metric }).value;

    return {
      conversions: Number(conversions ?? 0),
      views: Number(views ?? 0),
      variantID: IVariantType.VARIANT_A,
    };
  }, [metrics]);
  const variation = useMemo<GroupProps>(() => {
    const metric = metrics?.find((m) => m?.variantKey === IVariantType.VARIANT_B);
    const views = getTotalSessionMetric({ metric }).value;
    const conversions = getTotalSessionCompletedCheckoutMetric({ metric }).value;

    return {
      conversions: Number(conversions ?? 0),
      views: Number(views ?? 0),
      variantID: IVariantType.VARIANT_B,
    };
  }, [metrics]);

  const winner = useDetermineWinner({
    control,
    variation,
  });
  return useMemo(() => winner.values, [winner.values]);
};
